const state = {
  orders:{},
  currentOrderPicking:{},
  currentProductPicking:null
}

export default state
